var map = {
	"./services.jpg": "3f1a",
	"./services1.jpg": "d429",
	"./services2.jpg": "8c9f",
	"./services3.jpg": "fb62",
	"./services4.jpg": "85c5",
	"./services5.jpg": "9fb5",
	"./services6.jpg": "c45b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c179";